import {connect} from 'react-redux';
import ShopViewComponent from "../components/ShopViewComponent";
import {shopByIdSelector, userByIdSelector} from "../../_data/selectors";
import {toggleActiveModal} from "../../_widgets/modal/actions";
import {shopProfileActiveModalSelector} from "../selectors";
import {ActiveModalState} from "../../_definitions/styleteq";

const mapDispatchToProps = (dispatch, props) => {

    return {

        toggleMapModal: (modalState: ActiveModalState) => {
            if (modalState.key != "shop.map") {
                // reinit modal state if previously opened modal is not this modal
                modalState.key = "shop.map";
                modalState.active = false;
            }

            dispatch(toggleActiveModal({
                key: modalState.key,
                active: !modalState.active
            }));
        }
    };
};

const mapStateToProps = (state, props) => {
    const shop = shopByIdSelector(state, parseInt(props.match.params.shopId));

    return {
        shop: shop,
        shopOwner: shop && userByIdSelector(state, shop.userId),
        activeModal: shopProfileActiveModalSelector(state)
    };
};

const ShopViewContainer = connect(mapStateToProps, mapDispatchToProps)(ShopViewComponent);
export default ShopViewContainer;


// WEBPACK FOOTER //
// ./app/client/shop/container/ShopViewContainer.ts